import { IconName } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { getReservationOverviewUrl } from '../../../router/selectors';
import createConnectedButton from '../utils/createConnectedButton';
import { RESERVATION_OVERVIEW_SHORTCUT, navigateToReservationOverview } from '../../shortcuts';
import { trackAppNavbarEvent } from '../actions';

export default createConnectedButton({
    propSelectors: {
        url: getReservationOverviewUrl,
    },
    actions: (dispatch: $TSFixMe) => ({
        onClick: () => {
            dispatch(trackAppNavbarEvent('/commander/reservationoverviewreport/index'));
            dispatch(navigateToReservationOverview());
        },
    }),
    defaultProps: {
        icon: IconName.ReservationPreview,
        title: TextKey.ReservationOverview,
        shortcut: RESERVATION_OVERVIEW_SHORTCUT,
    },
});
